import type { SubtitleRecord } from '../db/idb.js';

/**
 * 履歴の書き出し。
 * 現地の社員が復習に使い、日本側へ共有する経路でもあるため、
 * Excel でそのまま開ける CSV を必ず用意する。
 */

export function toPlainText(records: SubtitleRecord[]): string {
  return records
    .map((r) => `[${formatTime(r.startedAt)}]\n${r.sourceZh}\n${r.translatedJa}\n`)
    .join('\n');
}

export function toCsv(records: SubtitleRecord[]): string {
  const rows = [['時刻', '中国語原文', '日本語訳', '用語集バージョン'].join(',')];
  for (const r of records) {
    rows.push(
      [r.startedAt, r.sourceZh, r.translatedJa, r.glossaryVersion].map(escapeCsv).join(','),
    );
  }
  // Excel の文字化けを防ぐため BOM を付ける。
  return `\uFEFF${rows.join('\r\n')}\r\n`;
}

export function toJson(records: SubtitleRecord[]): string {
  return JSON.stringify(records, null, 2);
}

function escapeCsv(value: string): string {
  if (/[",\r\n]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

function formatTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleTimeString('ja-JP');
}

/** ブラウザにファイルとして保存させる。 */
export function downloadFile(filename: string, content: string, mime: string): void {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // すぐ revoke するとダウンロードが始まらない端末があるため少し待つ。
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function timestampForFilename(date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}` +
    `-${pad(date.getHours())}${pad(date.getMinutes())}`
  );
}
